import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Route, Switch, Redirect } from 'react-router';
import { withRouter } from 'react-router-dom';
import { Layout } from './components/Layout';

import { Dashboard } from './components/datamanager/dashboard/Dashboard';
import { Lanes } from './components/datamanager/lanes/Lanes';
import { ProviderLanes } from './components/datamanager/providerLanes/ProviderLanes';
import { ProviderPointsOfInterest } from './components/datamanager/pointsOfInterest/ProviderPointsOfInterest';
import { Lines } from './components/datamanager/lines/Lines';
import { Paths } from './components/datamanager/paths/Paths';
import { Stops } from './components/datamanager/stops/Stops';
import { PathStops } from './components/datamanager/pathStops/PathStops';
import { MapPoints } from './components/datamanager/mapPoints/MapPoints';
import { Zones } from './components/datamanager/zones/Zones';
import { ZoneTypes } from './components/datamanager/zoneTypes/ZoneTypes';
import { Schedules } from './components/datamanager/schedules/Schedules';
import { PassingTimes } from './components/datamanager/passingTimes/PassingTimes';
import { DayTypes } from './components/datamanager/dayTypes/DayTypes';
import { SetOfDayTypes } from './components/datamanager/setOfDayTypes/SetOfDayTypes';
import { Calendar } from './components/datamanager/calendar/Calendar';
import { Currencies } from './components/datamanager/currencies/Currencies';
import { FareProducts } from './components/datamanager/fareProducts/FareProducts';
import { Editions } from './components/datamanager/editions/Editions';
import { LineColors } from './components/datamanager/lineColors/LineColors';
import { Import } from './components/datamanager/import/Import';
import { Export } from './components/datamanager/export/Export';
import { Messages } from './components/datamanager/messages/Messages';
import { ListDocuments } from './components/datamanager/documents/ListDocuments';

import { LayoutConfigurations } from './components/bussched/layoutConfigurations/LayoutConfigurations';
import { GenerateSchedules } from './components/bussched/schedules/native/Generate';
import { ListSchedules } from './components/bussched/schedules/List';
import { FontsResources } from './components/bussched/resources/FontsResources';
import { DataUpdates } from './components/bussched/updates/DataUpdates';

import { NewBusMap } from './components/busmap/NewBusMap';
import { ListBusMaps } from './components/busmap/ListBusMaps';
import { BusMapSettings } from './components/busmap/BusMapSettings';

import { SpiderMap } from './components/spidermap/spidermap/SpiderMap';
import { ListSpiderMaps } from './components/spidermap/list/ListSpiderMaps';
import { SettingsSpiderMaps } from './components/spidermap/settings/SettingsSpiderMaps';

import { Interfaces } from './components/files/interfaces/Interfaces';

import { Setup } from './components/Setup';
import { NotFound } from './components/NotFound';

import { LoginPage } from './components/LoginPage';
import { AuthenticationCallback } from './components/AuthenticationCallback';

import { authenticationCentral } from './authentication/Authentication';

import { storage, SELECTED_APP, SELECTED_PROVIDER, TOKEN_INFO/*, EDITION*/ } from './app/Storage';
import { appManager } from './app/AppManager';
import { Edition } from './app/Edition';
import { customBusSchedManager } from './app/CustomBusSchedManager';
import { decode } from 'jsonwebtoken';

class App extends Component {
    static childContextTypes = {
        selectedApp: PropTypes.object,
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        selectProvider: PropTypes.func,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func,
        getOwnEdition: PropTypes.func,
        cleanEdition: PropTypes.func,
        editionsModifications: PropTypes.object,
        setEditionsModifications: PropTypes.func,
        setSelectedMenuItem: PropTypes.func,
        selectedMenuItem: PropTypes.string,
        setSelectedMenuItemTitle: PropTypes.func,
        selectedMenuItemTitle: PropTypes.string,
        showMetadataButton: PropTypes.bool,
        setShowMetadataButton: PropTypes.func
    }

    displayName = App.name

    constructor(props) {
        super(props);

        const selectedApp = appManager.getApp(storage.get(SELECTED_APP) || 'datamanager');
        const selectedProvider = storage.get(SELECTED_PROVIDER) || undefined;
        const edition = new Edition(() => this.updateEdition(), selectedProvider, false);
        // try {
        //     edition = Edition.fromJson(storage.get(EDITION), () => this.updateEdition());
        // }
        // catch (_) { }

        this.state = {
            loading: true,
            selectedApp: selectedApp,
            selectedProvider: selectedProvider,
            edition: edition,
            editionsModifications: null,
            setup: typeof authUrl !== 'undefined' && typeof apiDataManagerUrl !== 'undefined' && typeof apiBusSchedUrl !== 'undefined'
                && typeof apiBusMapUrl !== 'undefined' && typeof clientId !== 'undefined'
        };
    }

    componentDidMount() {
        if (!this.state.setup) {
            return;
        }

        authenticationCentral.loadData().then(() => {
            this.setState({
                loading: false
            }, () => {
                const { edition } = this.state;
                edition.updateSync(new Date());
            });
        });
    }

    getChildContext() {
        return {
            selectedApp: this.state.selectedApp,
            selectApp: (a, b) => this.setSelectedApp(a, b),
            selectedProvider: this.state.selectedProvider,
            selectProvider: (a, b) => this.setSelectedProvider(a, b),
            edition: this.state.edition,
            addEditionObserver: (a) => this.addEditionObserver(a),
            removeEditionObserver: (a) => this.removeEditionObserver(a),
            getOwnEdition: (a) => this.getOwnEdition(a),
            cleanEdition: () => this.cleanEdition(),
            editionsModifications: this.state.editionsModifications,
            setEditionsModifications: (a) => this.setEditionsModifications(a),
            setSelectedMenuItemTitle: (a) => this.setSelectedMenuItemTitle(a),
            setSelectedMenuItem: (a) => this.setSelectedMenuItem(a),
            selectedMenuItemTitle: this.state.selectedMenuItemTitle,
            selectedMenuItem: this.state.selectedMenuItem,
            showMetadataButton: this.state.showMetadataButton,
            setShowMetadataButton: (a) => this.setShowMetadataButton(a)
        };
    }

    setShowMetadataButton = (state) => {
        this.setState({ showMetadataButton: state });
    }

    setSelectedMenuItem = (menuItem) => {
        this.setState({ selectedMenuItem: menuItem });
    }

    setSelectedMenuItemTitle = (menuItemTitle) => {
        this.setState({ selectedMenuItemTitle: menuItemTitle });
    }

    setSelectedApp(app, redirect) {
        storage.set(SELECTED_APP, app);
        this.setState({
            selectedApp: appManager.getApp(app)
        });

        if (redirect) {
            this.props.history.push(`/${app}`);
        }
    }

    setSelectedProvider(provider, redirect) {
        // Update edition provider
        const { edition } = this.state;
        if (null !== edition) {
            edition.setProvider(provider);
        }

        // Update selected Provider
        storage.set(SELECTED_PROVIDER, provider);
        this.setState({
            selectedProvider: provider
        });

        if (redirect) {
            window.location.reload();
        }
    }

    addEditionObserver(component) {
        const { edition } = this.state;

        if (null === edition) {
            const { selectedProvider } = this.state;

            const newEdition = new Edition(() => this.updateEdition(), selectedProvider);
            newEdition.addObserver(component);

            this.setState({
                edition: newEdition
            }, () => {
                this.updateEdition();
            });
        }
        else {
            edition.addObserver(component);
        }
    }

    removeEditionObserver(component) {
        const { edition } = this.state;

        if (null !== edition) {
            edition.removeObserver(component);
        }
    }

    getOwnEdition(isToUpdate = true) {
        return new Edition(undefined, undefined, isToUpdate);
    }

    cleanEdition() {
        // storage.remove(EDITION);
        this.setState({
            edition: null
        });
    }

    setEditionsModifications(editionsModifications) {
        this.setState({
            editionsModifications: editionsModifications
        });
    }

    updateEdition() {
        // const { edition } = this.state;
        // storage.set(EDITION, Edition.toJson(edition));
    }

    render() {
        if (this.state.setup) {
            if (!this.state.loading) {
                if (authenticationCentral.isLoggedIn && !authenticationCentral.isTokenExpired && !authenticationCentral.shouldCheckSession) {
                    const { selectedApp } = this.state;
                    let startPageComponent;

                    switch (selectedApp.path) {
                        case "datamanager":
                        case "bussched":
                        case "busmap":
                        case "spidermap":
                            startPageComponent = `/${selectedApp.path}`;
                            break;

                        default:
                            startPageComponent = "/notFound";
                            break;
                    }

                    let customBusSchedGenerator = false;
                    let customBusSchedGeneratorId = undefined;
                    let tokenInfo = storage.get(TOKEN_INFO);

                    if (typeof tokenInfo !== 'undefined') {
                        var json = JSON.parse(tokenInfo);
                        tokenInfo = Object.assign({}, json);
                    }

                    if (tokenInfo.id_token) {
                        let idToken = decode(tokenInfo.id_token);

                        if (idToken.cbsg && "True" === idToken.cbsg) {
                            customBusSchedGenerator = true;
                            customBusSchedGeneratorId = idToken.cbsg_id;
                        }
                    }

                    const generator = customBusSchedGenerator ? customBusSchedManager.getGenerator(customBusSchedGeneratorId) : GenerateSchedules;
                    const generatorConfigs = customBusSchedGenerator ? customBusSchedManager.getGeneratorConfigs(customBusSchedGeneratorId) : {};

                    return (
                        <Layout>
                            <Switch>
                                <Redirect exact from='/' to={startPageComponent} />
                                <Route path='/callback' component={AuthenticationCallback} />
                                <Route exact path='/datamanager' component={Dashboard} />
                                <Route path='/datamanager/dashboard' component={Dashboard} />
                                <Route path='/datamanager/lanes' component={Lanes} />
                                <Route path='/datamanager/providerLanes' component={ProviderLanes} />
                                <Route path='/datamanager/providerPointsOfInterest' component={ProviderPointsOfInterest} />
                                <Route path='/datamanager/lines' component={Lines} />
                                <Route path='/datamanager/paths' component={Paths} />
                                <Route path='/datamanager/stops' component={Stops} />
                                <Route path='/datamanager/pathstops' component={PathStops} />
                                <Route path="/datamanager/mapPoints" component={MapPoints} />
                                <Route path='/datamanager/zones' component={Zones} />
                                <Route path='/datamanager/zoneTypes' component={ZoneTypes} />
                                <Route path='/datamanager/schedules' component={Schedules} />
                                <Route path='/datamanager/dayTypes' component={DayTypes} />
                                <Route path='/datamanager/setOfDayTypes' component={SetOfDayTypes} />
                                <Route path='/datamanager/calendar' component={Calendar} />
                                <Route path='/datamanager/editions' component={Editions} />
                                <Route path='/datamanager/lineColors' component={LineColors} />
                                <Route path='/datamanager/passingTimes' component={PassingTimes} />
                                <Route path='/datamanager/import' component={Import} />
                                <Route path='/datamanager/export' component={Export} />
                                <Route path='/datamanager/currencies' component={Currencies} />
                                <Route path='/datamanager/fareProducts' component={FareProducts} />
                                <Route path='/datamanager/interfaces' component={Interfaces} />
                                <Route path='/datamanager/messages' component={Messages} />
                                <Route path='/datamanager/documents' render={(props) => <ListDocuments generatorConfigs={generatorConfigs} {...props} />} />
                                <Route exact path='/bussched' component={generator} />
                                <Route exact path='/bussched/schedules' component={generator} />
                                <Route path='/bussched/schedules/generate' component={generator} />
                                <Route path='/bussched/schedules/list' render={(props) => <ListSchedules generatorConfigs={generatorConfigs} {...props} />} />
                                <Route path='/bussched/updates' component={customBusSchedGenerator ? DataUpdates : null} />
                                <Route path='/bussched/layoutConfigurations' component={!customBusSchedGenerator || (customBusSchedGenerator && customBusSchedGeneratorId === "SMTUC") ? 
                                    LayoutConfigurations : null} />
                                <Route path='/bussched/fontsResources' component={!customBusSchedGenerator || (customBusSchedGenerator && customBusSchedGeneratorId === "SMTUC") 
                                    ? FontsResources : null} />
                                <Route path='/busmap/new' component={NewBusMap} />
                                <Route path='/busmap/list' component={ListBusMaps} />
                                <Route path='/busmap/settings' component={BusMapSettings} />
                                <Route exact path='/busmap' component={NewBusMap} />
                                <Route exact path='/spidermap' component={SpiderMap} />
                                <Route path='/spidermap/list' component={ListSpiderMaps} />
                                <Route path='/spidermap/settings' component={SettingsSpiderMaps} />
                                <Route path='*' component={NotFound} />
                            </Switch>
                        </Layout>
                    );
                } else {
                    return (
                        <div>
                            <Switch>
                                <Route exact path='/' component={LoginPage} />
                                <Route path='/callback' component={AuthenticationCallback} />
                                <Route path='*' component={LoginPage} />
                            </Switch>
                        </div>
                    );
                }
            } else {
                return (
                    <div />
                );
            }
        } else {
            return (
                <div>
                    <Route path='/' component={Setup} />
                </div>
            );
        }
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js